// assets
import Sponsor1 from "../assets/sponsors/AO-Arena.jpeg";
import Sponsor2 from "../assets/sponsors/chapelhouse-slider.jpeg";
import Sponsor3 from "../assets/sponsors/spa-seven.JPG";
import Sponsor4 from "../assets/sponsors/george-hill-timber.jpeg";
import Sponsor5 from "../assets/sponsors/HPL-Motors.png";
import Sponsor6 from "../assets/sponsors/minnieandteds.JPG";
import Sponsor7 from "../assets/sponsors/New York New York Sponsor Logo.JPEG";
import Sponsor8 from "../assets/sponsors/bury-market.jpeg";
import Sponsor9 from "../assets/sponsors/bjs-bingo.jpeg";
import Sponsor10 from "../assets/sponsors/dale-bathrooms.jpeg";
import Sponsor11 from "../assets/sponsors/franklyn.JPG";
import Sponsor12 from "../assets/sponsors/lshauto.PNG";
import Sponsor13 from "../assets/sponsors/zouk.jpeg";
import Sponsor14 from "../assets/sponsors/bents.jpeg";
import Sponsor15 from "../assets/sponsors/wilmslow-tavern.jpeg";
import Sponsor16 from "../assets/sponsors/trafford-centre.jpeg";
import Sponsor17 from "../assets/sponsors/future-skills.jpeg";
import Sponsor18 from "../assets/sponsors/Lomarton.jpeg";
import Sponsor19 from "../assets/sponsors/Lookers Polestar.jpg";
import Sponsor20 from "../assets/sponsors/ms-lending.png";
import Sponsor21 from "../assets/sponsors/move.jpeg";
import Sponsor22 from "../assets/sponsors/second-sim.jpeg";
import Sponsor23 from "../assets/sponsors/resin-driveways.jpeg";

export const sponsorData = [
  {
    src: Sponsor1,
    url: "https://www.ao-arena.com/",
  },
  {
    src: Sponsor2,
    url: "https://www.chapelhouse.co.uk/",
  },
  {
    src: Sponsor3,
    url: "https://www.spaseven.co.uk/",
  },
  {
    src: Sponsor4,
    url: "https://georgehill-timber.co.uk/",
  },
  {
    src: Sponsor5,
    url: "https://www.hplmotors.co.uk/",
  },
  {
    src: Sponsor6,
    url: "https://minnieandteds.co.uk/",
  },
  {
    src: Sponsor7,
    url: "https://www.newyorknewyorkbar.co.uk/",
  },
  {
    src: Sponsor8,
    url: "https://www.burymarket.com/",
  },
  {
    src: Sponsor9,
    url: "https://www.bjsbingo.co.uk/",
  },
  {
    src: Sponsor10,
    url: "https://www.dalebathrooms.com/",
  },
  {
    src: Sponsor11,
    url: "https://www.franklynfm.co.uk/",
  },
  {
    src: Sponsor12,
    url: "https://www.lshauto.co.uk/",
  },
  // {
  //   src: Sponsor13,
  //   url: "https://zoukteabar.co.uk/",
  // },
  {
    src: Sponsor14,
    url: "https://www.bents.co.uk/",
  },
  // {
  //   src: Sponsor15,
  //   url: "https://www.wilmslowtavernwilmslow.co.uk/",
  // },
  {
    src: Sponsor16,
    url: "https://traffordcentre.co.uk/",
  },
  {
    src: Sponsor17,
    url: "https://www.salfordcc.ac.uk/",
  },
  {
    src: Sponsor18,
    url: "https://lomarton.com/",
  },
  // {
  //   src: Sponsor19,
  //   url: "https://www.lookers.co.uk/polestar",
  // },
  // {
  //   src: Sponsor20,
  //   url: "https://www.mslendinggroup.co.uk/",
  // },
  // Move (Trafford Leisure) - UTM query parameters are appended automatically by Sponsors component
  {
    src: Sponsor21,
    url: "https://twmove.co.uk/",
  },
  // Second Sim - Clean URL ending in slash ensures ?utm_source attaches properly without duplicate query delimiters
  {
    src: Sponsor22,
    url: "https://www.secondsim.co.uk/",
  },
  // Resin Driveway Showrooms
  {
    src: Sponsor23,
    url: "https://resindrivewayshowrooms.com/",
  },
];
